<script>
	import { onMount } from 'svelte';
    import { Link } from 'svelte-routing';
	import { currentUser } from '../store/store.js';
	import { User } from '../utils/login.js';
	import { fetchBrfs } from '../utils/search.js';
	import Header from '../components/Header.svelte';
	import TopBar from '../components/TopBar.svelte';
	import Search from '../components/Search.svelte';
	import UploadFile from '../components/UploadFile.svelte';

	onMount(async () => {
		window.scrollTo(0, 0);
		fetchBrfs();
		await checkAuthStatus();
	});

	async function checkAuthStatus() {
		try {
			const storedUser = localStorage.getItem('currentUser');
			if (storedUser) {
				try {
					const userData = JSON.parse(storedUser);
					currentUser.set(new User(userData));
					return true;
				} catch (e) {
					console.error("Error parsing stored user data:", e);
					localStorage.removeItem('currentUser'); // Clear invalid data
				}
			}
			
			// Check if we have a token in cookies before making the request
			// This prevents the 401 error when no authentication exists
			const hasAuthCookie = document.cookie.split(';').some(cookie => 
				cookie.trim().startsWith('auth=') || cookie.trim().startsWith('session=')
			);
			
			if (!hasAuthCookie) {
				// No auth cookie found, skip the server request
				return false;
			}
			
			// Only try server authentication if we might have a valid session
			try {
				const response = await fetch(`https://boanalys-backend-324523837899.europe-north1.run.app/users/me`, {
					credentials: 'include',
					headers: {
						'Accept': 'application/json'
					}
				});
				
				if (response.ok) {
					const userData = await response.json();
					
					// Create user object
					const userObj = new User({
						accessToken: userData.access_token,
						type: userData.type,
						numberOfAnalysis: userData.number_of_analysis,
						username: userData.username
					});
					
					// Store in localStorage for future use
					localStorage.setItem('currentUser', JSON.stringify(userObj));
					
					// Set user in store
					currentUser.set(userObj);
					
					return true;
				} else if (response.status === 401) {
					// User is not authenticated
					currentUser.set(null);
					localStorage.removeItem('currentUser'); // Clear any stale data
					return false;
				} else {
					// Other error
					console.error(`Authentication check failed: ${response.status} ${response.statusText}`);
					return false;
				}
			} catch (error) {
				console.error("Error checking authentication status:", error);
				return false;
			}
		} catch (error) {
			console.error("Error checking authentication status:", error);
			return false;
		}
	}

	$: {
		// Move afterUpdate logic into a reactive statement
		document.title = "Boanalys - AI-driven analys av bostadsrättsföreningar";
		
		let metaDescription = document.querySelector('meta[name="description"]');
		if (!metaDescription) {
			metaDescription = document.createElement('meta');
			metaDescription.setAttribute('name', 'description');
			document.head.appendChild(metaDescription);
		}
		metaDescription.setAttribute('content', 'Boanalys använder artificiell intelligens för att analysera bostadsrättsföreningar. Få djupgående insikter om ekonomi, drift och underhåll för smartare bostadsbeslut.');
		
		let canonical = document.querySelector('link[rel="canonical"]');
		if (!canonical) {
			canonical = document.createElement('link');
			canonical.setAttribute('rel', 'canonical');
			document.head.appendChild(canonical);
		}
		canonical.setAttribute('href', 'https://boanalys.io/');
	}
</script>

<main>
	<TopBar />

	<Header />

	<h1 class="visually-hidden">Boanalys - AI-driven analys av bostadsrättsföreningar</h1>
	<div style="margin-top: 15vh;">
		<Search />
	</div>

	<div style=" padding-right: 15px; padding-left: 15px; margin-top: 60px;">
		<UploadFile />
	</div>
	<div class="key-value-table solo-table" style="max-width: 330px; margin-top: 60px;">
		<h3>Främjar insikt<br>med artificiell intelligens</h3>
		<p></p>
		<p class="upload-instructions">Boanalys är ett AI-företag som banar vägen för nästa generation av analysverktyg för privatpersoner och företag</p>
		<p class="upload-instructions">Vill du veta mer om oss?</p>
		<p></p>
        <Link to="/about">
            <button class="action-button">Läs mer</button>
        </Link>
	</div>
	<div class="about">
		<!--<button>Läs mer</button>-->
		<div class="info-text">
			Boanalys kan begå misstag då mycket bygger på AI. Kontrollera viktig information.
			<br>
			Om din förening inte finns med i listan - skapa ett konto och ladda upp årsredovisningen. 
			<br>
		</div>
	</div>
</main>
<footer>
	<p>©Boanalys. All rights reserved.</p>
	<p><Link to="/about#kontakt-section">Kontakta oss</Link></p>
</footer>

<style>
	/* Add this for accessibility without affecting design */
	.visually-hidden {
		position: absolute;
		width: 1px;
		height: 1px;
		margin: -1px;
		padding: 0;
		overflow: hidden;
		clip: rect(0, 0, 0, 0);
		border: 0;
	}

	.solo-table .action-button { /* Style the button inside */
		background-color: #343a40;
		color: white;
		padding: 10px 20px;
		border: none;
		border-radius: 8px;
		cursor: pointer;
		font-weight: 600;
		transition: background-color 0.2s, transform 0.1s ease, box-shadow 0.2s ease;
		display: inline-block;
		text-align: center;
		font-size: 0.9rem;
		box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
		margin-top: 10px; /* Add some space above the button */
	}
	.solo-table .action-button:hover {
		background-color: #495057;
		transform: translateY(-2px);
		box-shadow: 0 5px 10px rgba(0, 0, 0, 0.15);
	}
	.solo-table .action-button:active {
		transform: translateY(0px);
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	}
</style>